import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "label-filled",
  "use": "label-filled-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"label-filled\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 12.52V3.48C0 3.215.232 3 .519 3h10.623c.138 0 .27.05.367.14l3.773 3.493c.245.227 1.476 1.367.015 2.72l-3.788 3.506a.54.54 0 01-.367.141H.52c-.288 0-.52-.215-.52-.48zm10.309-5.24a1 1 0 101.39 1.437 1 1 0 00-1.39-1.437z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol